import './aggrid-modules'
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router'
import ErrorBoundary from './components/ErrorBoundary'
import Layout from './components/Layout'
import { NotFound } from './components/NotFound'
import OrderRouter from './contexts/OrderRouter'
import AcceptInvitationPage from './pages/AcceptInviationPage'
import BulkPaymentEntryPage from './pages/BulkPaymentEntryPage'
import ClientPage from './pages/ClientPage'
import ClientsPage from './pages/ClientsPage'
import ContactsPage from './pages/ContactsPage'
import HomePage from './pages/HomePage'
import ImportPage from './pages/ImportPage'
import OrganizationPage from './pages/OrganizationPage'
import VendorPage from './pages/VendorPage'
import VendorsPage from './pages/VendorsPage'
import AddProjectPage from './pages/projects/AddProjectPage'
import EditProjectPage from './pages/projects/EditProjectPage'
import ProjectPage from './pages/projects/ProjectPage'
import ProjectsPage from './pages/projects/ProjectsPage'
import AddRFQPage from './pages/rfqs/AddRfqPage'

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Layout />} ErrorBoundary={ErrorBoundary}>
      <Route index element={<HomePage />} />
      <Route path="projects" element={<ProjectsPage />} />
      <Route path="projects/new" element={<AddProjectPage />} />
      <Route path="projects/:projectId" element={<ProjectPage />} />
      <Route path="projects/:projectId/edit" element={<EditProjectPage />} />
      <Route path="rfqs/new" element={<AddRFQPage />} />
      <Route path="clients" element={<ClientsPage />} />
      <Route path="clients/:clientId" element={<ClientPage />} />
      <Route path="contacts" element={<ContactsPage />} />
      <Route path="vendors" element={<VendorsPage />} />
      <Route path="vendors/:vendorId" element={<VendorPage />} />
      <Route path="org" element={<OrganizationPage />} />
      <Route path="import" element={<ImportPage />} />
      <Route path="accept-invitation/:token" element={<AcceptInvitationPage />} />
      <Route path="order/*" element={<OrderRouter />} />
      <Route path="payment-entry" element={<BulkPaymentEntryPage />} />
      <Route path="*" element={<NotFound />} />
    </Route>,
  ),
)

export default function AppRouter() {
  return (
    <>
      <RouterProvider router={router} />
    </>
  )
}
